import Phaser from 'phaser';
import Character, { preload as preloadCharacter } from '../../objects/test/CharacterVectors';

export default class CharacterVectorsObject extends Phaser.Scene {
  constructor() {
    super({ key: 'CharacterVectorsObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadCharacter.call(this);
  }

  create() {
    this.physics.world.setBoundsCollision(true);
    
    this.player = new Character({
      scene: this,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
    });

    this.tweens.add({
      targets: this.player,
      alpha: 1,
      duration: 500,
      onStart: () => this.player.move(),
      onComplete: () => {
        this.player.looseHead();
        this.player.stop();
      },
    });
  }
}
